import axios from "axios";

const envBaseUrl = import.meta.env.VITE_BASE_URL;

axios.defaults.baseURL = `${envBaseUrl}/api/v1`;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

export default axios;
